import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import LottieView    from 'lottie-react-native';
import { StyleSheet, View, TextInput, ActivityIndicator, TouchableOpacity, ScrollView, Platform } from 'react-native';
import { Screen, Button, Input, Text, Routes, Line, Icon } from '../components';
import { PetAddScreen, SignInUniversal } from '../containers';
import { ArrayUtils, StringUtils } from '../utils';
import PetController  from '../controllers/petController';
import AuthController from '../controllers/authController';
import UserController from '../controllers/userController';
import { useNavigate, useLocation } from 'react-router-dom';

class PetListScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_sign_in: false
    }
  }

  async componentDidMount() {
     if (this.cat_animation) {
      this.cat_animation.play();
     }

     this.pull_pets();

     if (Platform.OS !== 'web') {
       this.props.navigation.addListener('focus', async () => {
         this.pull_pets();
       });
     }
  }

  goToPet(patient_id) {
    if(Platform.OS === 'web') {
      let path = `${Routes.PET_DETAILS}?patient_id=${patient_id}`
      this.props.navigate(path);
    } else {
      this.props.navigate(Routes.PET_DETAILS, {patient_id})
    }
  }

  render_pets_list = () => {
     let pets     = this.state.pets || [];
     let pet_rows = pets.map((pet, index) => {
       let is_last = index === pets.length - 1;
           is_last = false;
       let pet_id  = pet._id;
       let name    = StringUtils.displayName(pet);
       let gender  = StringUtils.sentenceCase(pet.gender.toLowerCase());
       let type    = StringUtils.sentenceCase(pet.type.toLowerCase());
       let descrpt = gender + ' ' + type;
       let age     = '';

       if (pet.age) {
         age = ', Age ' + pet.age;
       }

       if (pet.birthday) {
         age = ', Age ' + StringUtils.displayBirthdayAge(pet.birthday)
       }

       return <View key={pet_id}>
         <TouchableOpacity style={{ marginTop: 20, marginBottom: 20, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
                           onPress={ () => {this.goToPet(pet_id)
                           }}>
          <View>
            <Text style={{ fontSize: 16, fontWeight: '500', color: '#040415' }}>{ name }</Text>
            <Text style={{ fontSize: 14, color: '#575762', marginTop: 3 }}>{ descrpt + age }</Text>
          </View>
          <Icon name='chevron-right' solid={true} size={15} color={'#cccccc'} />
         </TouchableOpacity>
         <Line hide={is_last} />
       </View>
     })

     let no_pets_message = pet_rows && pet_rows.length === 0 ? true : false;
     let is_mobile       = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

     return <View style={{ marginBottom: 10 }}>
      { no_pets_message ? <View style={{ alignItems: 'center' }}>
                            { is_mobile ? <LottieView ref={animation => { this.cat_animation = animation }} style={{ width: 140, height: 140, backgroundColor: '#F7F8FA' }} source={require('../assets/animations/cat-tail-wag.json')} />
                                        : <Icon name={'cat'} solid={true} size={80} style={{ marginBottom: 20 }} /> }
                            <Text style={{ fontSize: 18, fontWeight: '500', textAlign: 'center', color: '#040415', paddingTop: 2 }}>{ 'No pets added' }</Text>
                            <Text style={{ fontSize: 16, textAlign: 'center', color: '#575762', paddingBottom: 20 }}>{ "Let's add your first pet" }</Text>
                          </View>
                        : pet_rows }
     </View>
  }

  render_add_pet_button = () => {
    return <View style={{ marginTop: 5 }}>
      <TouchableOpacity onPress={ () => { this.props.navigate(Routes.PET_ADD) }} style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Icon name='plus-circle' solid={true} />
        <View style={{ marginLeft: 15 }}>
          <Text style={{ fontSize: 16, fontWeight: '500', color: '#535353' }}>{ 'Add A New Pet' }</Text>
          <Text style={{ fontSize: 14, color: '#575762', marginTop: 3 }}>{ 'Add another pet to your account' }</Text>
        </View>
      </TouchableOpacity>
      <Line style={{ marginTop: 15, marginBottom: 15 }} />
      <Button title={ 'Back To Home' }
              onPress={ async () => {
                this.goBack();
              }}/>
    </View>
  }

  render() {

    return (
      <Screen navigation={this.props.navigation} title={'Pet List'} scroll={true} auth={true} auth_success={() => { this.pull_pets() }}>
        <View style={{ padding: 20 }}>
          { this.render_pets_list()      }
          { this.render_add_pet_button() }
        </View>
      </Screen>
    );
  }

  sign_in_success = () => {
    this.setState({ display_sign_in: false });
  }

  async pull_pets() {
    let pets_response = await PetController.getAllPets();

    if(pets_response && pets_response.success && pets_response.patients) {
      let pets            = pets_response.patients;
      let total_pet_count = pets && pets.length ? pets.length : 0;

      pets.forEach(async pet => {
        let details = pet && pet.patient_details ? ArrayUtils.getSingleObject(pet.patient_details) : null;
        await this.enter_pet_to_airtable(details, total_pet_count);
      })

      let pet_details_array = pets.map((pet, i) => {
        let details = pet && pet.patient_details ? ArrayUtils.getSingleObject(pet.patient_details) : null;
        return details;
      }).filter((deets) => { return deets });

      this.setState({ pets: pet_details_array });
    }
  }

  enter_pet_to_airtable = async (pet_details, total_pet_count) => {
    let user = await AuthController.getUser();

    let user_data = {
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      phone_number: user.phone_number,
      pet_name: pet_details.name,
      pet_birthday: pet_details.birthday,
      pet_type: pet_details.type,
      pet_breed: pet_details.breed,
      pet_gender: pet_details.gender,
      pet_deleted: 'false',
      pet_number: total_pet_count.toString(),
    }

    let air_table_response = await UserController.sendDataToAirTable(user_data);
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }
}

const useLocationChange = (action) => {
  const location = useLocation()
  React.useEffect(() => { console.log('location', location); action(location);  }, [location])
}

function PetListScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    let screenRef = React.createRef();

    useLocationChange((location) => {
      console.log('handle route change here', location)
      screenRef.pull_pets();
    })

    return  <PetListScreen_Base ref={node=>{screenRef = node}} {...props} navigate={navigate} />
  } else {
    props.navigation.addListener( 'focus', () => { screenRef && screenRef.pull_pets ? screenRef.pull_pets() : null });
    return  <PetListScreen_Base ref={node=>{screenRef = node}} {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({

});

export default PetListScreen
